module.exports = __webpack_public_path__ + "img/game3.1a2eb311.png";